// Gives the clicked product card's image the shared view-transition name, so with cross-document
// View Transitions it morphs into the first photo on the product page. Names are cleared when the
// page is shown again (back/forward cache) so only one element ever carries the name.
const NAME = 'niya-product';

document.addEventListener('click', (event) => {
  const card = event.target.closest?.('a[data-vt-card]');
  if (!card || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
  document.querySelectorAll('a[data-vt-card]').forEach((el) => { el.style.viewTransitionName = ''; });
  card.style.viewTransitionName = NAME;
});

window.addEventListener('pageshow', () => {
  document.querySelectorAll('a[data-vt-card]').forEach((el) => { el.style.viewTransitionName = ''; });
});
